module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-human-f7ee96dc195091911764c9567ecc86b3.svg";